import { Base } from '@studiometa/js-toolkit';

/**
 * Variant Selects
 */
export default class VariantSelects extends Base {
  dropdownOpen = false;

  /**
   * Component Configuration
   */
  static config = {
    name: 'VariantSelects',
    refs: ['disabledBtn[]', 'btnDropdown', 'dropdown', 'icon'],
    emits: ['update-availability'],
  };

  mounted() {
    this.currentColor = window.currentColor;
    this.gallery = document.querySelector('#gallery');
  }

  /**
   * When changing variation
   * @returns {void}
   */
  onChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '');
    // this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    this.$update();
  }

  /**
   * Click outside
   * @returns {void]}
   */
  onDocumentClick() {
    this.closeDropdown();
  }

  /**
   * Click on first tab of select
   * @param  {object} event current element
   * @returns {void}
   */
  onBtnDropdownClick(event) {
    event.stopPropagation();
    if (this.dropdownOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  /**
   * Open Dropdown
   * @returns {void}
   */
  openDropdown() {
    this.dropdownOpen = true;
    this.$refs.dropdown.classList.remove('hidden');
    this.$refs.icon.classList.add('rotate-180');
  }

  /**
   * Close Dropdown
   * @returns {void}
   */
  closeDropdown() {
    this.dropdownOpen = false;
    this.$refs.dropdown.classList.add('hidden');
    this.$refs.icon.classList.remove('rotate-180');
  }

  /**
   * Open Restock popup
   * @returns {void}
   */
  onDisabledBtnClick() {
    setTimeout(() => {
      document.querySelector('.restock-alerts-notify-button').click();
    }, 200);
  }

  /**
   * Update Options
   * @returns {void}
   */
  updateOptions() {
    this.options = Array.from(this.$el.querySelectorAll('select'), (select) => select.value);
  }

  /**
   * Update Master ID
   * @returns {void}
   */
  updateMasterId() {
    // Code initial pour trouver le variant basé sur toutes les options
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    // Si aucun variant n'est trouvé, chercher basé sur `option1`
    if (this.currentVariant === undefined) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.option1 === this.options[0];
      });
    }
  }

  /**
   * Update Gallery based on current variation
   * @returns {void}
   */
  updateMedia(html) {
    if (!this.currentVariant) return;
    if (this.currentColor === this.options[0] || this.currentColor == undefined) return;

    [this.currentColor] = this.options;

    this.gallery.style.height = `${this.gallery.offsetHeight}px`;

    const gallerySource = html.querySelector('#gallery');
    if (gallerySource) {
      this.gallery.classList.add('hide');

      setTimeout(() => {
        this.gallery.innerHTML = gallerySource.innerHTML;
        setTimeout(() => {
          this.gallery.classList.remove('hide');
          this.gallery.style.height = null;
          this.$parent.$update();
        }, 200);
      }, 500);
    }
  }

  /**
   * Update URL with variant selection
   * @returns {void}
   */
  updateURL() {
    if (!this.currentVariant || this.$el.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.$el.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  /**
   * Update Share Url
   * @returns {void}
   */
  updateShareUrl() {
    const shareButton = document.querySelector(`#Share-${this.$el.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.$el.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  /**
   * Update variant input
   * @returns {void}
   */
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.$el.dataset.section}, #product-form-installment-${this.$el.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /**
   * Update variant statuses
   * @returns {void}
   */
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.$el.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.$el.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) => variant.available && variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  /**
   * Set Input Availability
   * @param {Array} listOfOptions
   * @param {Array} listOfAvailableOptions
   */
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.textContent = input.getAttribute('value');
      } else {
        input.textContent = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'),
        );
      }
    });
  }

  /**
   * Update Pickup Availability
   * @returns {void}
   */
  updatePickupAvailability() {
    this.$emit('update-availability', this.currentVariant.id, this.currentVariant.available);
  }

  /**
   * Remove Error message
   * @returns {void}
   */
  removeErrorMessage() {
    const section = this.$el.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  /**
   * Render Product Info
   * @returns {void}
   */
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.$el.dataset.originalSection
      ? this.$el.dataset.originalSection
      : this.$el.dataset.section;

    fetch(
      `${this.$el.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.$el.dataset.originalSection
          ? this.$el.dataset.originalSection
          : this.$el.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        console.log(requestedVariantId);
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        console.log('test 1');

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const destination = document.querySelector(`#price-${this.$el.dataset.section}`);
        const source = html.querySelector(
          `#price-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const availabilitiesDestination = document.querySelector('#availabilities');
        const availabilitiesSource = html.querySelector('#availabilities');

        const skuSource = html.querySelector(
          `#Sku-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );
        const skuDestination = document.querySelector(`#Sku-${this.$el.dataset.section}`);

        const variantsSource = html.querySelector(
          `#variant-radios-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const variantsDestination = document.querySelector(
          `#variant-radios-${this.$el.dataset.section}`,
        );

        const inventorySource = html.querySelector(
          `#Inventory-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );
        const inventoryDestination = document.querySelector(
          `#Inventory-${this.$el.dataset.section}`,
        );

        const volumePricingSource = html.querySelector(
          `#Volume-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const pricePerItemDestination = document.querySelector(
          `#Price-Per-Item-${this.$el.dataset.section}`,
        );
        const pricePerItemSource = html.querySelector(
          `#Price-Per-Item-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const volumePricingDestination = document.querySelector(
          `#Volume-${this.$el.dataset.section}`,
        );
        const qtyRules = document.querySelector(`#Quantity-Rules-${this.$el.dataset.section}`);
        const volumeNote = document.querySelector(`#Volume-Note-${this.$el.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (variantsSource && variantsDestination) {
          variantsDestination.innerHTML = variantsSource.innerHTML;
          variantsDestination.classList.toggle(
            'hidden',
            variantsSource.classList.contains('hidden'),
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            'hidden',
            pricePerItemSource.classList.contains('hidden'),
          );
        }

        if (availabilitiesSource && availabilitiesDestination) {
          availabilitiesDestination.innerHTML = availabilitiesSource.innerHTML;
        }

        const price = document.querySelector(`#price-${this.$el.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.textContent === '');

        const addButtonUpdated = html.querySelector(`#ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        );

        this.updateMedia(html);

        // eslint-disable-next-line no-undef
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });

        this.$parent.$update();
        this.dropdownOpen = false;
      });
  }

  /**
   * Toggle add Button
   * @param  {boolean} disable
   * @param  {string}  text
   * @returns {void}
   */
  toggleAddButton(disable = true, text = '') {
    const productForm = document.querySelector(`#product-form-${this.$el.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.dataset.ref = 'disabledBtn[]';
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('data-ref', 'disabledBtn[]');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  /**
   * Set Unvailable to btn
   */
  setUnavailable() {
    const button = document.querySelector(`#product-form-${this.$el.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.querySelector(`#price-${this.$el.dataset.section}`);
    const inventory = document.querySelector(`#Inventory-${this.$el.dataset.section}`);
    const sku = document.querySelector(`#Sku-${this.$el.dataset.section}`);
    const pricePerItem = document.querySelector(`#Price-Per-Item-${this.$el.dataset.section}`);
    const volumeNote = document.querySelector(`#Volume-Note-${this.$el.dataset.section}`);
    const volumeTable = document.querySelector(`#Volume-${this.$el.dataset.section}`);
    const qtyRules = document.querySelector(`#Quantity-Rules-${this.$el.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  /**
   * Get variant Data
   * @returns {Array}
   */
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.$el.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
